// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"524":"6661e585","826":"f2d8fff4"}[chunkId] + ".css";
};